module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bg-white max-height-vertical max-height-auto box-overflow"
  }, [_c('full-span-slide', {
    attrs: {
      "active": _vm.active
    }
  }, [_c('div', {
    staticClass: "span-16-lg span-16-mg span-16-sm span-16-xs text-center"
  }, [_c('h1', [_vm._v("Thank You")]), _vm._v(" "), _c('p', [_vm._v("This project is made possible by "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Verizon")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("With support from The Jonathan Logan Family Foundation.")]), _vm._v(" "), _c('p', [_vm._v("Developed by "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Futures Without Violence")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-both-24 sponsor-image-container"
  }, [_c('div', {
    staticClass: "span-4-lg span-4-md ratio-4-3 bg-image-span bg-fwv"
  }), _vm._v(" "), _c('div', {
    staticClass: "span-4-lg span-4-md offset-2-lg offset-2-md ratio-4-3 bg-image-span bg-verizon"
  }), _vm._v(" "), _c('div', {
    staticClass: "span-4-lg span-4-md offset-2-lg offset-2-md ratio-4-3 bg-image-span bg-jlff"
  })]), _vm._v(" "), _c('div', {
    staticClass: "span-16-lg span-16-mg span-16-sm span-16-xs text-center"
  }, [_c('p', [_vm._v("Based in part on the curricula "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Changing Minds: A Leadership Institute for Educators and Community Partners")]), _vm._v(" developed under "), _c('br'), _vm._v("the Office of Juvenile Justice and Delinquency Prevention, U.S. Department of Justice, and"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Middle School Matters")]), _vm._v(", a project of the Jonathan Logan Family Foundation.")])]), _vm._v(" "), _c('div', {
    staticClass: "p utility disclaimer text-center"
  }, [_vm._v("Points of view or opinions expressed in this document are those of the authors and do not necessarily represent the official position or policies of OJJDP or the U.S. Department of Justice.")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9c51ef4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/pages/sponsor_page.vue
// module id = 656
// module chunks = 1